

<app-header
    *ngIf="!(_router.url === '/')"></app-header>
<!-- <app-header></app-header> -->
<div class="main-content" style="padding-top: var(--header-height, 0px);">
  <app-loader></app-loader>
  <app-agenq-widget *ngIf="showAgenq"></app-agenq-widget>
  <router-outlet></router-outlet>
</div>
<app-footer *ngIf="!(_router.url === '/')"></app-footer>
